import React, { useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import PharmacyProfileSidebar from "../Components/PharmacyProfileSidebar";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { changeprofilepassword } from "../network/Network";

const PharmacyPassword = () => {
  const token = useSelector((state) => state?.Auth?.token);
  const myrole = useSelector((state) => state?.Auth?.role);
  const [selected, setSelected] = useState("");
  const [formErrors, setFormErrors] = useState([]);
  const [oldpassword1, setOldpassword1] = useState(false);
  const [newpassword1, setNewpassword1] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cpassword1, setCpassword1] = useState(false);
  const [userData, setUserData] = useState({
    current_password: "",
    new_password: "",
    confirm_password: "",
  });

  //   Input Handler
  function handleChange(e) {
    const value = e.target.value;
    setUserData({ ...userData, [e.target.name]: value });
  }
  // ================

  // New Password Funcitonality
  const Newpassowrd = (e) => {
    e.preventDefault();
    setLoading(true);

    let isValid = true;
    const errors = {};

    // Validate Password
    if (!userData || !userData.current_password) {
      if (!errors || !errors.current_password) {
        if (!errors) errors = {};
        errors.current_password = [];
      }
      errors.current_password.push("Password is required");
      isValid = false;
    } else if (userData.current_password.length < 8) {
      if (!errors || !errors.current_password) {
        if (!errors) errors = {};
        errors.current_password = [];
      }
      errors.current_password.push(
        "Password must be at least 8 characters long"
      );
      isValid = false;
    }

    // Validate Password
    if (!userData || !userData.new_password) {
      if (!errors || !errors.new_password) {
        if (!errors) errors = {};
        errors.new_password = [];
      }
      errors.new_password.push("Password is required");
      isValid = false;
    } else if (userData.new_password.length < 8) {
      if (!errors || !errors.new_password) {
        if (!errors) errors = {};
        errors.new_password = [];
      }
      errors.new_password.push("Password must be at least 8 characters long");
      isValid = false;
    }

    // Validate Confirm Password
    if (!userData || !userData.confirm_password) {
      if (!errors || !errors.confirm_password) {
        if (!errors) errors = {};
        errors.confirm_password = [];
      }
      errors.confirm_password.push("Confirm Password is required");
      isValid = false;
    } else if (userData.new_password !== userData.confirm_password) {
      if (!errors || !errors.confirm_password) {
        if (!errors) errors = {};
        errors.confirm_password = [];
      }
      errors.confirm_password.push("Passwords do not match");
      isValid = false;
    }

    setFormErrors(errors);

    setTimeout(() => {
      setFormErrors([]);
    }, 3000);

    let data = {
      current_password: userData?.current_password,
      password: userData?.new_password,
      confirm_password: userData?.confirm_password,
    };

    changeprofilepassword(data, token, myrole)
      .then((res) => {
        Swal.fire({
          position: "center",
          icon: "success",
          text: "Password Has Been Changed",
          showConfirmButton: false,
          timer: 1700,
        });
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  // ==================
  return (
    <>
      <Header />
      <PageHeader pagename="Pharmacy Profile" />
      <section className="main-sidebar user-profile">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <PharmacyProfileSidebar />
            </div>
            <div className="col-lg-8">
              <div className="main-profile-content radius-20 p-4">
                <div className="main-headind d-flex align-items-center 	gap-3 mb-3">
                  <div className="edit-btn back">
                    <Link>
                      <div className="nav-anchor">
                      </div>
                    </Link>
                  </div>
                  <h5 className="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
                    Change Password
                  </h5>
                </div>
                <form>
                  <div className="row">
                    <div className="form-group col-lg-12">
                      <input
                        type={oldpassword1 ? "text" : "password"}
                        className="form-control"
                        id="firstName"
                        placeholder=" Old Password"
                        name="current_password"
                        onChange={handleChange}
                        value={userData?.current_password}
                      />

                      <div className="eye_icon">
                        <button
                          className="input-inline-btn shop-password"
                          type="button"
                          onClick={() => setOldpassword1(!oldpassword1)}
                        >
                          <i
                            className={
                              oldpassword1 ? "fa fa-eye-slash" : "fa fa-eye"
                            }
                          ></i>
                        </button>
                      </div>
                    </div>
                    <p className="forms-error">
                      {formErrors?.current_password}
                    </p>
                    <div className="form-group col-lg-12">
                      <input
                        type={newpassword1 ? "text" : "password"}
                        className="form-control"
                        id="lastName"
                        placeholder=" New Password"
                        name="new_password"
                        onChange={handleChange}
                        value={userData?.new_password}
                      />
                      <button
                        className="input-inline-btn shop-password"
                        type="button"
                        onClick={() => setNewpassword1(!newpassword1)}
                      >
                        <i
                          className={
                            newpassword1 ? "fa fa-eye-slash" : "fa fa-eye"
                          }
                        ></i>
                      </button>
                    </div>
                    <p className="forms-error">{formErrors?.new_password}</p>

                    <div className="form-group col-lg-12">
                      <input
                        type={cpassword1 ? "text" : "password"}
                        className="form-control"
                        id="lastName"
                        placeholder="Confirm Password"
                        name="confirm_password"
                        onChange={handleChange}
                        value={userData?.confirm_password}
                      />
                      <button
                        className="input-inline-btn shop-password"
                        type="button"
                        onClick={() => setCpassword1(!cpassword1)}
                      >
                        <i
                          className={
                            cpassword1 ? "fa fa-eye-slash" : "fa fa-eye"
                          }
                        ></i>
                      </button>
                    </div>
                    <p className="forms-error">
                      {formErrors?.confirm_password}
                    </p>
                  </div>
                  <Link className="btn wrapper-btn-main mb-5 log-in mt-3 level-7 primary-regular-font text-decoration-none">
                    <span
                      onClick={(e) => Newpassowrd(e)}
                      className="loading-btn loading bg-wrapper "
                    >
                      {loading ? (
                        <i className="fa fa-spinner"></i>
                      ) : (
                        "Save Changes"
                      )}
                    </span>
                  </Link>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default PharmacyPassword;
